// #region Imports
import React, { useEffect, useState } from 'react';
import useComissoes from '../../hooks/useComissoes';
import useFuncionarios from '../../hooks/useFuncionarios';
import ComissoesTable from '../../components/Comissoes/ComissoesTable/ComissoesTable';
import ComissaoCrud from '../../components/Comissoes/ComissaoCrud/ComissaoCrud';
// #endregion

export default function ComissoesPage() {
  // #region Hooks
  const {
    listar,
    obter,
    criar,
    atualizar,
    remover,
    alternarStatus,
    comissoes,
    computeStats,
    loading,
  } = useComissoes();
  const { funcionarios } = useFuncionarios();
  const vendasMock = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }];
  // #endregion

  // #region Estado página
  const [filters, setFilters] = useState({
    q: '',
    funcionario_id: 'TODOS',
    status: 'TODOS',
    periodo: 'TODOS',
  });
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [listState, setListState] = useState({ data: [], total: 0 });
  const [editingId, setEditingId] = useState(null);
  const [crudOpen, setCrudOpen] = useState(false);
  // #endregion

  // #region Efeito listar
  useEffect(() => {
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }, [listar, filters, page, pageSize]);
  // #endregion

  // #region Derivados
  const stats = computeStats(comissoes);
  const editing = editingId ? obter(editingId) : null;
  // #endregion

  // #region Handlers filtros & CRUD
  function handleFiltersChange(next) {
    setFilters(next);
    setPage(1);
  }

  function handleCreate() {
    setEditingId(null);
    setCrudOpen(true);
  }

  function handleEdit(id) {
    setEditingId(id);
    setCrudOpen(true);
  }

  function handleDelete(id) {
    remover(id);
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }

  function handleSave(payload) {
    if (editingId) atualizar(editingId, payload); else criar(payload);
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
    setCrudOpen(false);
  }

  function handleToggleStatus(id) {
    alternarStatus(id);
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }
  // #endregion

  // #region Render
  return (
    <div className="comissoes-page">
      <ComissoesTable
        loading={loading}
        stats={stats}
        filters={filters}
        data={listState.data}
        total={listState.total}
        page={page}
        pageSize={pageSize}
        funcionarios={funcionarios}
        onFiltersChange={handleFiltersChange}
        onPageChange={setPage}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onToggleStatus={handleToggleStatus}
      />
      <ComissaoCrud
        open={crudOpen}
        comissao={editing}
        funcionarios={funcionarios}
        vendas={vendasMock}
        onClose={() => setCrudOpen(false)}
        onSave={handleSave}
      />
    </div>
  );
  // #endregion
}
